import { render, staticRenderFns } from "./CardOrganizationTree.vue?vue&type=template&id=2ee9f276"
import script from "./CardOrganizationTree.vue?vue&type=script&lang=js"
export * from "./CardOrganizationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports